module.exports = __webpack_public_path__ + "static/media/truck_yellow.4b7cb72c.svg";